/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcIceJobV1TaskEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_ICE_JOB_V1_TASK_EVENT_ENTITY_NAME = 'exc.ice.job.v1.TaskEvent';
export const excIceJobV1TaskEventEntity = new schema.Entity<ExcIceJobV1TaskEvent>(EXC_ICE_JOB_V1_TASK_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: ExcIceJobV1TaskEvent) => `${entity.metadata?.eventId}` });

